import { ERoleName } from '../models/enums/role.enum';
import { StateService } from '../services/state/state.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

/**
 * Keeps the auditors marketplace route unavailable to the Auditor role.
 */
@Injectable({
  providedIn: 'root',
})
export class AuditorsMarketplaceAccessGuard implements CanActivate {
  public constructor(
    private readonly _stateService: StateService,
    private readonly _router: Router
  ) {}

  /**
   * Allows the route or redirects auditors to home.
   * @param {ActivatedRouteSnapshot} _route - Activated route snapshot.
   * @param {RouterStateSnapshot} _state - Target router state.
   * @returns {boolean} Access result.
   */
  public canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (this._stateService.selectedRole() !== ERoleName.AUDITOR) {
      return true;
    }

    void this._router.navigate(['/home']);

    return false;
  }
}
